import { track } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'control_subscribe';


export default (emailAddress) => {
  track(EVENT_NAME, { email: emailAddress }, { force: true, important: true, once: true });
};



// WEBPACK FOOTER //
// ./src/lib/track-event/subscribe.js